export default __webpack_public_path__ + "static/media/boardingIcon.6cef7699.svg";